import React, { useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { getCouponsBasedOnDomainAction } from "../../../../Store/CouponBaseOnDomain/actions";

import { getCouponByIdAction } from "../../../../Store/Coupons/actions";
import "../../../../Assets/Scss/newHome2.scss";
import { getImageUrlhttps } from "../../../../Utils/index";
import PlaceHolderImage from "../../../../Assets/Images/PlaceholderImage.png";
import CentralCouponRedirect from "../../../../Utils/CentralCouponRedirect";

import { getCouponUrlAction } from "../../../../Store/couponUrl/actions";

function Deals({ history, match }) {
  const dispatch = useDispatch();

  const { couponbaseondomainList } = useSelector(
    (store) => store.CouponBasedOnDomain
  );
  const { link } = useSelector((state) => state.CouponUrl);

  const [redirect, setRedirect] = useState(false);
  const [redirect2, setRedirect2] = useState(false);
  const [newTab, setNewTab] = useState(false);
  const [second, setSecond] = useState(false);
  const [useRedirectComponent, setUseRedirectComponent] = useState(false);

  const { couponByID } = useSelector((state) => state.Coupon);

  useEffect(() => {
    if (couponbaseondomainList.length === 0) {
      dispatch(getCouponsBasedOnDomainAction());
    }
  }, [couponbaseondomainList, dispatch]);

  useEffect(() => {
    if (
      match?.params?.couponId !== undefined &&
      couponByID?._id === undefined
    ) {
      dispatch(getCouponByIdAction({ coupon_id: match.params.couponId }));
    }
    if (
      match?.params?.couponId !== undefined &&
      couponByID?._id !== undefined
    ) {
      window.open(
        `/couponsredirect/${match.params.storeName}/${match.params.couponId}`
      );
    }
  }, [match, couponByID, dispatch]);

  useEffect(() => {
    localStorage.setItem("link", link);
    if (redirect) {
      setNewTab(!newTab);
    }
    if (redirect2) {
      setNewTab(!newTab);
    }
  }, [link, newTab, redirect, redirect2, second]);

  useEffect(() => {
    if (link && redirect) {
      setRedirect(false);
      window.open(`/meta-redirect/`, "_blank");
    }
    if (link && redirect2) {
      setRedirect2(false);
      window.open(link, "_blank");
    }
  }, [link, newTab, redirect, redirect2]);

  return (
    <div style={{ background: "#f0f0f0" }} className="pt-0">
      {useRedirectComponent && (
        <CentralCouponRedirect
          e={useRedirectComponent.e}
          coupon={useRedirectComponent.coupon}
          setUseRedirectComponent={setUseRedirectComponent}
        ></CentralCouponRedirect>
      )}
      <Container id="recommended-res-cards">
        <div
          class="three"
          style={{
            padding: "2vh 1.5vw",
          }}
        >
          <h1>Recommended</h1>
        </div>
        <Row className="deals-i2">
          {couponbaseondomainList.slice(0, 16).map((coupon, index) => (
            <Col xl="3" sm="6">
              <div className="a-box">
                <div className="img-container">
                  <div className="img-inner">
                    <div className="inner-skew">
                      <img
                        src={getImageUrlhttps(
                          coupon.image ? coupon.image : coupon?.store?.image,
                          PlaceHolderImage
                        )}
                        alt=""
                        loading="lazy"
                      />
                    </div>
                  </div>
                </div>
                <div className="text-container">
                  <h3 style={{ color: "#e90a96" }}>{coupon?.store?.name}</h3>
                  <div style={{ color: "#f82caa" }}>
                    {coupon?.title?.length > 35
                      ? coupon?.title.substring(0, 35) + "..."
                      : coupon?.title}
                  </div>
                  <br />

                  <button
                    id="show-code-button"
                    // onClick={(e) => {
                    //   e.stopPropagation();
                    //   dispatch(
                    //     getCouponUrlAction(
                    //       coupon?._id,
                    //       `${window.screen.width}x${window.screen.height}`,
                    //       `/couponsredirect/store/$store/coupon/store/${coupon?._id}`
                    //     )
                    //   );

                    //   if (link) {
                    //     setSecond(true); //to run useEffect even when link has not changed
                    //   }

                    //   if (
                    //     coupon?.redirection_type ===
                    //     "zero-redirect-without-refer"
                    //   ) {
                    //     setRedirect(true);
                    //   } else if (
                    //     coupon?.redirection_type === "zero-redirect-with-refer"
                    //   ) {
                    //     setRedirect2(true);
                    //   } else {
                    //     localStorage.setItem(
                    //       "redirection_type",
                    //       coupon?.redirection_type
                    //     );

                    //     window.open(
                    //       `/couponsredirect/store/store/coupon/store/${coupon?._id}`,
                    //       "_blank"
                    //     );
                    //   }
                    // }}
                    onClick={(e) => {
                      e.preventDefault();
                      setUseRedirectComponent({ e, coupon });
                    }}
                  >
                    Show code
                  </button>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
      <br />
    </div>
  );
}

export default Deals;
